import React from 'react';
import { useReveal } from '../hooks';

export const Reveal = ({ children, className = "", delay = 0 }) => {
  const [ref, isVisible] = useReveal();
  return (
    <div
      ref={ref}
      className={`transition-all duration-1000 transform ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};
